var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeftLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4497 3.49558L10.377 2.42285L4.37695 8.42285L10.377 14.4229L11.4497 13.3501L6.52241 8.42285L11.4497 3.49558Z",
    fill: "#9095A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftLarge);
export default __webpack_public_path__ + "static/media/chevron-left-large.e51a5566edc40389ab4fff780037c3d1.svg";
export { ForwardRef as ReactComponent };